const CAROUSEL_ITEMS = [
  {
    title: '2026韩国电影年度盛典',
    desc: '《犯罪都市4》《破墓》《首尔之春》等年度现象级韩国大片高清合集，一页尽览韩国电影年度最强阵容。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20film%20award%20ceremony%20aesthetic%2C%20movie%20posters%20on%20red%20carpet%2C%20dramatic%20spotlight%20lighting%2C%20elegant%20film%20festival%20atmosphere%2C%20golden%20and%20burgundy%20color%20scheme&width=900&height=500&seq=crsl-01&orientation=landscape',
    tag: '年度精选',
  },
  {
    title: '宫崎骏经典动画回顾',
    desc: '从《千与千寻》到《你想活出怎样的人生》，宫崎骏与吉卜力工作室动画电影完整专题，日韩影视网高清收录。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20Ghibli%20film%20collage%2C%20whimsical%20fantasy%20worlds%2C%20soft%20hand-drawn%20animation%20textures%2C%20warm%20nostalgic%20color%20palette%2C%20floating%20castles%20and%20spirits%2C%20dreamy%20atmosphere&width=900&height=500&seq=crsl-02&orientation=landscape',
    tag: '大师专题',
  },
  {
    title: '日韩恐怖片午夜专场',
    desc: '《破墓》《咒怨》《午夜凶铃》等经典日韩恐怖片高清合集，胆大的来挑战，全程高能不断。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20eerie%20Japanese%20Korean%20horror%20film%20aesthetic%2C%20haunted%20house%20silhouette%2C%20foggy%20moonlit%20night%2C%20cold%20blue%20and%20gray%20tones%20with%20subtle%20red%2C%20atmospheric%20dread%2C%20minimalist%20composition&width=900&height=500&seq=crsl-03&orientation=landscape',
    tag: '类型专场',
  },
  {
    title: '日本纯爱电影治愈季',
    desc: '《余生那些年》《花束般的恋爱》《情书》等高分日本纯爱电影，治愈暖心，适合周末慢慢品味。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romance%20film%20aesthetic%2C%20cherry%20blossom%20scenery%2C%20soft%20pastel%20pink%20and%20cream%20color%20palette%2C%20gentle%20spring%20sunlight%2C%20dreamy%20bokeh%20effect%2C%20warm%20emotional%20atmosphere&width=900&height=500&seq=crsl-04&orientation=landscape',
    tag: '治愈专题',
  },
  {
    title: '韩国悬疑犯罪片高能合集',
    desc: '高智商犯罪、烧脑反转、紧张刺激，韩国悬疑犯罪片天花板合集，每一部都值得反复观看。',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Korean%20crime%20thriller%20film%20aesthetic%2C%20interrogation%20room%20scene%2C%20dramatic%20lighting%20through%20blinds%2C%20intense%20atmosphere%2C%20cool%20blue%20and%20warm%20amber%20contrast%2C%20film%20noir%20style&width=900&height=500&seq=crsl-05&orientation=landscape',
    tag: '类型专场',
  },
  {
    title: '日韩科幻奇幻视觉盛宴',
    desc: '《寄生兽》《汉江怪物》《与神同行》等视觉震撼的日韩科幻奇幻大片，脑洞大开，特效炸裂。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20fantasy%20film%20aesthetic%2C%20neon-lit%20cyberpunk%20cityscape%2C%20otherworldly%20atmosphere%2C%20blue%20and%20purple%20holographic%20tones%2C%20epic%20cinematic%20scale%2C%20dramatic%20composition&width=900&height=500&seq=crsl-06&orientation=landscape',
    tag: '视觉盛宴',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">专题合集</h2>
        <p className="text-sm text-foreground-500 mb-8">精心策划的日韩电影专题，发现更多好片</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap self-start">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mt-2 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}